import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, TwitterIcon, InstagramIcon, YouTubeIcon } from '../ui/Icons';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      icon: FacebookIcon,
      href: 'https://www.facebook.com/besst2022',
      label: 'Facebook',
      hoverColor: 'hover:bg-[#1877F2]'
    },
    {
      icon: TwitterIcon,
      href: 'https://x.com/besst_is_best',
      label: 'Twitter/X',
      hoverColor: 'hover:bg-black'
    },
    {
      icon: InstagramIcon,
      href: 'https://www.instagram.com/besst_edu_hub',
      label: 'Instagram',
      hoverColor: 'hover:bg-gradient-to-br hover:from-[#f09433] hover:via-[#dc2743] hover:to-[#bc1888]'
    },
    {
      icon: YouTubeIcon,
      href: 'https://youtube.com/@besst_edu_hub',
      label: 'YouTube',
      hoverColor: 'hover:bg-[#FF0000]'
    },
  ];

  const footerSections = {

    quickLinks: {
      title: 'Quick Links',
      links: [
        { label: 'All Courses', href: '/courses' },
        { label: 'Current Affairs', href: '/current-affairs' },
        { label: 'Blog', href: '/blog' },
      ]
    },
    support: {
      title: 'Support',
      links: [
        { label: 'FAQ', href: '/faq' },
        { label: 'Help Center', href: '/contact' },
        { label: 'Contact Us', href: '/contact' },
        { label: 'Privacy Policy', href: '/privacy-policy' },
        { label: 'Terms of Service', href: '/terms' },
      ]
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#0F0C29] to-[#24243e] pt-16 pb-8 border-t border-glass-border">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Section */}
          <div className="footer-section">
            <img
              src="/logo.png"
              alt="BESST"
              className="h-16 w-auto object-contain mb-4"
            />
            <p className="text-text-muted mb-6">
              Explore your potential with BESST
              {/* - Your trusted partner for exam success. Join us on a transformative learning journey and achieve your academic goals with confidence. */}
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-10 h-10 bg-glass-bg border border-glass-border rounded-full flex items-center justify-center text-white transition-all duration-300 hover:border-transparent hover:text-white hover:-translate-y-1 ${social.hoverColor}`}
                  aria-label={social.label}
                  title={social.label}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3>{footerSections.quickLinks.title}</h3>
            <ul className="space-y-3">
              {footerSections.quickLinks.links.map((link, index) => (
                <li key={index}>
                  <Link to={link.href}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div className="footer-section">
            <h3>{footerSections.support.title}</h3>
            <ul className="space-y-3">
              {footerSections.support.links.map((link, index) => (
                <li key={index}>
                  <Link to={link.href}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Subscribe */}
          <div className="footer-section">
            <h3>Stay Updated</h3>
            <p className="text-text-muted mb-4">
              Get the latest study tips and exam updates delivered to your inbox.
            </p>
            <form
              className="space-y-3"
              onSubmit={(event) => event.preventDefault()}
            >
              <label htmlFor="footer-email" className="sr-only">
                Email address
              </label>
              <input
                id="footer-email"
                type="email"
                name="email"
                placeholder="Enter your email"
                autoComplete="email"
                required
                className="w-full rounded-lg border border-glass-border bg-glass-bg px-4 py-3 text-white placeholder:text-text-muted focus:border-white focus:outline-none"
              />
              <button
                type="submit"
                className="w-full rounded-lg btn-primary px-4 py-3 font-semibold text-[#0F0C29] transition-colors hover:bg-gray-200"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="text-center pt-8 border-t border-glass-border text-text-muted">
          <p>© {currentYear} BESST - Brahmaputra Exam Success Support Team. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;